import { useSoftphoneAnnouncements } from 'Modules/softphone/hooks/useSoftphoneAnnouncements';

/**
 * Starts {@link CallAnnouncer} while the softphone is enabled.
 *
 * Live regions live in the shared `LiveAnnouncer` mounted from `Layout` —
 * keep this bridge out of the widget so "Call ended" still runs after it
 * closes, and so announcements work even when only this hook is mounted in tests.
 */
export const SoftphoneAnnouncer = (): null => {
  useSoftphoneAnnouncements();

  return null;
};
